/* Next */
import Head from 'next/head'

/* Types */
import { tProduct } from 'src/shared/frontendTypes/product'
import type { LandingPageImageAiGenerated } from 'src/functions/landingPageImageAiGenerated'

/* Components */
import Product from './Product'

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

interface Props {
  product: tProduct
  initialVariantKey?: string
  landingPageImageAiGenerated?: LandingPageImageAiGenerated
}

const ProductPage: React.FC<Props> = ({ product, initialVariantKey, landingPageImageAiGenerated }:Props) => {
  return <>
    <Head>
      <title>{product.metaTitle}</title>
    </Head>
    <Product {...{ product, initialVariantKey, landingPageImageAiGenerated }} />
  </>

}

export default ProductPage
